import { List } from "@phosphor-icons/react";
import { Link } from "react-router";

import { UserAvatar } from "@/client/components/user-avatar";
import { UserOptions } from "@/client/components/user-options";

import { NotificationBell } from "../notifications/notification-bell";
import { USER_SPACE_PATHS } from "../../config/navigation";

type MobileHeaderProps = {
  onMenuOpen: () => void;
};

export const MobileHeader = ({ onMenuOpen }: MobileHeaderProps) => {
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-slate-200 bg-white/95 px-4 backdrop-blur lg:hidden">
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onMenuOpen}
          aria-label="Ouvrir le menu"
          className="grid size-10 place-items-center rounded-xl text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-950 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <List aria-hidden size={24} />
        </button>

        <Link
          to={USER_SPACE_PATHS.dashboard}
          aria-label="Accéder au tableau de bord monCVpro"
          className="rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <img
            src="/logo/mon-cv-pro_logo.svg"
            alt="monCVpro"
            className="h-9 w-auto max-w-32 object-contain"
          />
        </Link>
      </div>

      <div className="flex items-center gap-1">
        <NotificationBell classNameTrigger="size-10 text-slate-600 hover:bg-slate-100 hover:text-slate-950 focus-visible:ring-indigo-500" />

        <UserOptions>
          <button
            type="button"
            aria-label="Ouvrir les options du compte"
            className="rounded-full p-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
          >
            <UserAvatar size={34} />
          </button>
        </UserOptions>
      </div>
    </header>
  );
};
